export default "__VITE_ASSET__b341f198__"